module.exports = __webpack_public_path__ + "img/abs_1.1c3116cf.png";